module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.errMsg) { 
    ; __append(" <h5 class=\"text-red\">")
    ; __append(escapeFn( locals.errMsg ))
    ; __append("</h5> ")
    ;  } else if (locals.reportTypeReadable) { 
    ; __append(" <div> <small><a href=\"/account/reports/")
    ; __append(escapeFn( locals.reportType ))
    ; __append("\">&lt; Back to ")
    ; __append(escapeFn( locals.reportTypeReadable ))
    ; __append("s</a></small> </div> <div class=\"row\"> <div class=\"col-md-5 col-sm-7\"> <div class=\"panel panel-default\"> <div class=\"panel-body\"> <h3 class=\"no-margin\">")
    ; __append(escapeFn( locals.reportTypeReadable ))
    ; __append("</h3> <h6 class=\"id\">")
    ; __append(escapeFn( locals.id ))
    ; __append("</h6> <dl> <dt>Created:</dt> <dd>")
    ; __append(escapeFn( locals.createdAtDate ))
    ; __append(" <small class=\"text-muted\">")
    ; __append(escapeFn( locals.createdAtTime ))
    ; __append("</small></dd> <dt>Report Date Range:</dt> <dd><span class=\"text-nowrap\">")
    ; __append(escapeFn( locals.startDate ))
    ; __append("</span><span class=\"daterange-separator\"></span><span class=\"text-nowrap\">")
    ; __append(escapeFn( locals.endDate ))
    ; __append("</span></dd> </dl> <div> ")
    ;  if (locals.status === 'available' || locals.url) { 
    ; __append(" <button class=\"btn btn-block btn-blue download-report\"> <span class=\"hidden-xs\">Download</span> <span class=\"glyphicon glyphicon-download\"></span> </button> ")
    ;  } else if (locals.status === 'failed') { 
    ; __append(" <h4 class=\"text-red bold\">Report Failed</h4> ")
    ;  } else if (locals.status === 'new' || locals.status === '') { 
    ; __append(" <div id=\"report_download_loader\" class=\"loader\"></div> ")
    ;  } 
    ; __append(" </div> </div> </div> </div> </div> ")
    ;  } else { 
    ; __append(" <div id=\"report_loader\" class=\"loader\"></div> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/report_detail_page.ejs
// module id = 866
// module chunks = 1